var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"right-btns"},[_c('span',{staticClass:"hash-tag"},[_vm._t("hash-tag")],2),(_setup.slots['hash-tag'])?_c('span',{staticClass:"divider"},[_vm._v(" |  ")]):_vm._e(),_c('span',{staticClass:"emoji-icon"},[_vm._t("emoji-icon")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }